export const DISABLE_CLICK_AWAY_PROP_NAME = 'data-disable-click-away';
